import AppRoutes from './routes/routes';

export default function App() {
  return <AppRoutes />;
}
